import { render, staticRenderFns } from "./CMobileBanner.vue?vue&type=template&id=2482ddd2&"
import script from "./CMobileBanner.vue?vue&type=script&lang=ts&"
export * from "./CMobileBanner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports